// frontend/src/context/AuthContext.js
import React, { createContext, useState, useContext, useCallback } from 'react';
import { jwtDecode } from 'jwt-decode';
import { getProfile } from '../services/profileService';
// import { App as AntApp } from 'antd'; // <-- REMOVED

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    // Initialize state from localStorage — clear token if it can't be decoded
    const [token, setToken] = useState(() => {
        const savedToken = localStorage.getItem('token');
        if (!savedToken) return null;
        try {
            jwtDecode(savedToken);
            return savedToken;
        } catch {
            localStorage.removeItem('token');
            return null;
        }
    });
    const [user, setUser] = useState(() => {
        const savedToken = localStorage.getItem('token');
        if (savedToken) {
            try {
                return jwtDecode(savedToken).user;
            } catch {
                return null;
            }
        }
        return null;
    });

    const login = (newToken) => {
        localStorage.setItem('token', newToken);
        setToken(newToken);
        try {
            setUser(jwtDecode(newToken).user);
        } catch (error) {
            setUser(null);
        }
    };

    const logout = () => {
        localStorage.removeItem('token');
        setToken(null);
        setUser(null);
        // Force reload to clear all state and redirect to login via interceptor
        if (window.location.pathname !== '/login') {
            window.location.href = '/login';
        }
    };

    // --- NEW: Role Synchronization Logic (Cleaned up) ---
    const syncRole = useCallback(async () => {
        if (!token || !user) return false; // Return false if not authenticated

        try {
            // Fetch the user's current data from the database
            const profile = await getProfile();

            // Compare the role currently in the JWT claim/local state with the live database role
            if (profile.role !== user.role) {
                // CRITICAL: Log out the user immediately 
                logout();

                // Return flag indicating a role change occurred
                return true;
            }
            return false;

        } catch (error) {
            // If fetching the profile fails (e.g., 401, user deleted), log out
            if (error.response?.status === 401 || error.response?.status === 404) {
                logout();
                return true;
            }
            return false;
        }
    }, [token, user, logout]);
    // --- END NEW ---


    return (
        <AuthContext.Provider value={{ token, user, login, logout, isAuthenticated: !!token, syncRole }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    return useContext(AuthContext);
};